import { LayoutPage } from "@/components/_layouts/LayoutPage/LayoutPage";
import { useScrollToTopOnMount } from "@/hooks/useScrollToTopOnMount";
import { Container, TypographyStylesProvider } from "@mantine/core";
import { ReactNode } from "react";

export const LayoutBoilerplateText = ({
  children,
}: {
  children: ReactNode;
}) => {
  useScrollToTopOnMount();

  return (
    <LayoutPage>
      <Container size="lg" my={"xl"}>
        <TypographyStylesProvider>{children}</TypographyStylesProvider>
      </Container>
    </LayoutPage>
  );
};
